import React from 'react';

const NumberFormatter = (props) => {
    if(!isNaN(props.num)){
        return props.num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    else {
        return "NaN";
    }

};
export default NumberFormatter;


// WEBPACK FOOTER //
// ./src/components/Common/NumberFormatter/NumberFormatter.js